export default {
  buttons: { done: 'Listo' },
  title: 'Ubicación',
};
